import React from "react"
import styled from "styled-components"
import { breakpointsMax } from "../res/styles/Common"
import { SectionBody } from "../res/styles/TextStyles"
import { useMediaQuery } from "react-responsive"

const Background = styled.div`
    width: 100%;
    min-height: 50vh;
    background-color: ${(props) => props.bg};
    display: flex;
`

const Row = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: ${(props) => (props.align ? props.align : "center")};
    justify-content: ${(props) =>
        props.justify ? props.justify : "flex-start"};
`

const Body = styled.div`
    max-width: 40%;
    margin: 85px 100px;
    margin-right: ${(props) => (props.left ? "20px" : "100px")};
    white-space: pre-line;
    @media ${breakpointsMax.tablet} {
        max-width: 90%;
        margin: 20px 0px;
    }
`

const Child = styled.div`
    max-width: 400px;
    margin: 20px;
`

function LayoutSelector(props) {
    const isMobile = useMediaQuery({ query: breakpointsMax.laptop })
    console.log(isMobile)
    let left = props.left

    if (isMobile && props.left) left = false

    return (
        <>
            {left ? <Child>{props.children}</Child> : <></>}
            <Body left={left}>
                <SectionBody
                    textColor={props.textColor}
                    align={!left ? "left" : "right"}
                >
                    {props.body}
                </SectionBody>
            </Body>
            {!left ? <Child>{props.children}</Child> : <></>}
        </>
    )
}

function Section(props) {
    return (
        <Background bg={props.bg}>
            <Row justify="space-around">
                <LayoutSelector
                    textColor={props.textColor}
                    left={props.left}
                    body={props.body}
                >
                    {props.children}
                </LayoutSelector>
            </Row>
        </Background>
    )
}

export default Section
